(ns admin.containers.curriculum.activities
  (:require
   [re-frame.core :as re-frame]

   [kyber.components.base.text :as text]
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.containers.not-found :as not-found]
   [kyber.components.composite.loading :as loading]
   [kyber.utils :as ku]

   [admin.components.composite.new-activity-button :as new-activity-button]
   [admin.components.composite.curriculum.activity-list :as activity-list]
   [admin.utils :as au]))

(def classes
  (styles->classes
   {:curriculum-container
    {:background-color (gs [:colors :true-white])
     :padding (gs [:spacing :p20])}

    :first-curriculum-container
    {:padding (gs [:spacing :p32])
     :display :flex
     :flex-direction :column
     :align-items :center
     :background-color (gs [:colors :gray-scale-50])
     :border (str "1px solid " (gs [:colors :gray-scale-100]))
     :border-radius (gs [:radius :r7])
     :margin-bottom (gs [:spacing :p32])}}))

(defn activity-row
  [{activity-name :name}]
  [:div
   [text/title-20 :p activity-name]])

(defn- published? [{:keys [published]}] (true? published))

(def not-published? (complement published?))

(defn- create-new-activity
  [{:keys [activity-count max-activities curriculum-uuid is-super-user]}]
  (let [exceeded-quota?
        (>= activity-count max-activities)

        base-button-options
        {:curriculum-uuid curriculum-uuid
         :exceeded-quota? exceeded-quota?
         :is-super-user is-super-user}]
    [:<>
     [:div {:style {:display :flex
                    :align-items :center
                    :margin-bottom (gs [:spacing :p20])}}
      [:div {:style {:display :flex
                     :align-items :center}}
       [text/title-10 :p
        {:style {:margin-right (gs [:spacing :p4])}}
        (str "Created " activity-count)]
       [text/body-20 :p
        {:style {:margin-right (gs [:spacing :p8])}}
        (str " of " max-activities)]]
      (when (pos? activity-count)
        [new-activity-button/render
         (assoc base-button-options :button-label "Create New Activity")])]
     (when (zero? activity-count)
       [:div {:class (:first-curriculum-container classes)}
        [text/title-40 :h3 {:style {:margin-bottom (gs [:spacing :p36])}}
         "You have no activities. Create your first!"]
        [new-activity-button/render
         (assoc base-button-options :button-label "Create your first Activity")]])]))

(defn render
  [_router-ctx curriculum {:keys [default-activity-route]}]
  (let [is-super-user
        (re-frame/subscribe [:authentication/has-access?
                             :is-super-user])

        is-updating-activity-sort-order
        (re-frame/subscribe [:request/is-dispatching
                             :curricula/update-curriculum-activity-sort-order])]

    (fn [{:keys [resource-status]}]
      (let [;; published (filterv published? @activities)
            ;; unpublished (filterv not-published? @activities)
            ;; total-activities (count @activities)

            {curriculum-uuid :uuid}
            @curriculum

            activities
            (re-frame/subscribe
             [:activities {:curriculum-uuid curriculum-uuid}])

            can-create-activities
            (re-frame/subscribe [:authentication/has-access?
                                 :activity/can-create
                                 {:curriculum-uuid curriculum-uuid}])

            {max-activities :max-number-of-activities
             activity-sort-order :activity-sort-order}
            @curriculum

            ;; TODO The sorting here can be removed once
            ;; https://github.com/Archemedx/kyber/issues/3924
            ;; has been addressed.
            standard-activities
            (->> @activities
                 (filter #(-> % :is-intro-activity false?))
                 (sort-by :name)
                 (sort-by :sort-order)
                 vec)

            standard-activity-lookup
            (into {} (map (juxt :uuid identity) standard-activities))

            ;; TODO Conditional can be removed once
            ;; https://github.com/Archemedx/kyber/issues/3924
            ;; has been addressed.
            ordered-standard-activities
            (filterv some?
                     (if (seq activity-sort-order)
                       (mapv #(get standard-activity-lookup %)
                             activity-sort-order)
                       standard-activities))

            intro-activity
            (->> @activities
                 (filter #(-> % :is-intro-activity true?))
                 first)]

        (if (ku/all-resources-loaded? resource-status)
          (if (some? @curriculum)
            [:div {:class (:curriculum-container classes)}
             (when (true? @can-create-activities)
               [create-new-activity
                {:activity-count (count @activities)
                 :max-activities max-activities
                 :curriculum-uuid curriculum-uuid
                 :is-super-user @is-super-user}])

             (when (some? intro-activity)
               [activity-list/render
                {:activities [intro-activity]
                 :default-activity-route default-activity-route
                 :curriculum-uuid curriculum-uuid
                 :title "Introduction Activity"
                 :description (str "The intro activity can be disabled from "
                                   "the curriculum settings page.")}])

             [activity-list/render
              {:activities
               ordered-standard-activities

               :default-activity-route
               default-activity-route

               :curriculum-uuid
               curriculum-uuid

               :title
               "Activities"

               :is-updating-sort
               @is-updating-activity-sort-order

               :on-sort-update
               (fn [{:keys [start end]}]
                 (re-frame/dispatch
                  [:curricula/update-curriculum-activity-sort-order
                   {:updated-activity-order
                    (->> ordered-standard-activities
                         (au/reorder-coll start end)
                         (mapv :uuid))

                    :curriculum-uuid
                    curriculum-uuid}]))

               :description
               (str "The order shown below is the order that "
                    "activities will be displayed to the "
                    "learners.")}]]
            [not-found/not-found {:source :curriculum}])
          [loading/render
           {:loading-message "Please wait while we fetch your activities"}])))))
